import { combineReducers } from 'redux';

const rootReducer = combineReducers({
	 state: (state = {}) => state
});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/index.js